import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { IGameTypeSpectator } from "../../IGameTypeSpectator";
import { TournamentTypeFreezeout } from "../TournamentTypeFreezeout";

export class TournamentTypeFreezeoutSpectator extends TournamentTypeFreezeout implements IGameTypeSpectator {
    public get isGameTypeSpectator(): boolean {
        return true;
    }
}
classImplementsInterfaces(TournamentTypeFreezeoutSpectator, "IGameTypeSpectator");
